<!-- YouTube home feed ad on the TV app -->
<app-tv-frame>
  <!-- START: TV screen -->
  <div class="yt-tvh-screen d-flex flex-row">
    <!-- START: Side rail. The app's own navigation, not the ad's, so the
         glyphs are fixed and the account circle is a placeholder. -->
    <div class="yt-tvh-rail d-flex flex-column align-items-center">
      <span class="yt-tvh-account"></span>

      <div class="yt-tvh-rail-group d-flex flex-column align-items-center">
        <i *ngFor="let icon of railIcons" class="bi bi-{{ icon }}"></i>
      </div>

      <div class="yt-tvh-rail-group yt-tvh-rail-bottom d-flex flex-column align-items-center">
        <i *ngFor="let icon of railIconsBottom" class="bi bi-{{ icon }}"></i>
      </div>
    </div>
    <!-- END: Side rail -->

    <!-- START: Feed. Both shelves run past the right edge of the screen, which
         is what the TV app's carousels do. -->
    <div class="yt-tvh-feed d-flex flex-column">
      <div class="yt-tvh-shelf-head d-flex flex-row align-items-center justify-content-between">
        <span class="yt-tvh-shelf-title">Recommended</span>
        <span class="yt-tvh-logo d-flex flex-row align-items-center">
          <i class="bi bi-youtube"></i>
          <span class="yt-tvh-wordmark">YouTube</span>
        </span>
      </div>

      <div class="yt-tvh-shelf d-flex flex-row">
        <!-- START: Real ad — the shelf's focused card, hence the ring. -->
        <div class="yt-tvh-card">
          <div class="yt-tvh-thumb yt-tvh-thumb-focused">
            <img
              *ngIf="thumbnailUrl; else noCreative"
              class="yt-tvh-creative"
              [src]="thumbnailUrl"
              alt=""
            />

            <ng-template #noCreative>
              <div class="yt-tvh-creative creative-missing">
                <ng-container *ngIf="isResolving; else askForVideo">
                  Reading video formats&hellip;
                </ng-container>
                <ng-template #askForVideo>
                  Add a {{ format }} video to see this preview
                </ng-template>
              </div>
            </ng-template>

            <!-- Only drawn over a creative — unreadable on the empty card. -->
            <span class="yt-tvh-countdown" *ngIf="thumbnailUrl">00:08</span>
          </div>

          <h4 class="yt-tvh-title">{{ headline }}</h4>

          <!-- Fixed copy: the view count is the app's, not the author's. -->
          <div class="yt-tvh-meta">
            <strong>Sponsored</strong> &middot; Valamar &middot; 356K views
          </div>

          <div class="yt-tvh-ad-options d-flex flex-row align-items-center">
            <i class="bi bi-record-circle"></i>
            <span>Press and hold for ad options</span>
          </div>
        </div>
        <!-- END: Real ad -->

        <div class="yt-tvh-card" *ngFor="let filler of fillersBesideAd">
          <div class="yt-tvh-thumb"></div>
          <span class="yt-tvh-bar yt-tvh-bar-full"></span>
          <span class="yt-tvh-bar yt-tvh-bar-mid"></span>
          <span class="yt-tvh-bar yt-tvh-bar-short"></span>
        </div>
      </div>

      <div class="yt-tvh-shelf-head">
        <span class="yt-tvh-shelf-title">New to you</span>
      </div>

      <!-- Cut off by the screen edge, so only the tops of these show. -->
      <div class="yt-tvh-shelf d-flex flex-row">
        <div class="yt-tvh-card" *ngFor="let filler of fillersBelowAd">
          <div class="yt-tvh-thumb"></div>
        </div>
      </div>
    </div>
    <!-- END: Feed -->
  </div>
  <!-- END: TV screen -->
</app-tv-frame>
